import Img, { Props as ImgProps } from '../Img';
import src from '../../assets/images/logos/moneytree.png';
import './styles.scss';

type Props = Omit<Omit<ImgProps, 'src'>, 'alt'>;

export default function Sprout({ className = '', ...rest }: Props) {
  return (
    <Img
      {...rest}
      className={`moneytree-logo-sprout ${className}`}
      src={src}
      alt="sprout icon"
    />
  );
}
